var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef } from '@angular/core';
import { BaseComponent } from "../../views/base.component";
import { EventsService } from "../../lib/EventsService";
import { ActivatedRoute } from "@angular/router";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { TranslateService } from "../../translate";
import { MailService } from "../mail.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../../auth.service";
import dictionaries from "dict/static.json";
var SendTestComponent = /** @class */ (function (_super) {
    __extends(SendTestComponent, _super);
    function SendTestComponent(eventsService, service, activatedRoute, filter, translate, modalService, authService, mailService) {
        var _this = _super.call(this, eventsService, service, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.service = service;
        _this.activatedRoute = activatedRoute;
        _this.filter = filter;
        _this.translate = translate;
        _this.modalService = modalService;
        _this.authService = authService;
        _this.mailService = mailService;
        _this.lng = 'ru';
        _this.inProgress = false;
        _this.resultMessage = '';
        _this.mailTabGroups = [];
        _this.mailTabGroups = dictionaries.mailGroups;
        return _this;
    }
    SendTestComponent.prototype.sendTest = function (action) {
        return __awaiter(this, void 0, void 0, function () {
            var me, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.inProgress = true;
                        me.modalService.open(me.modalProgress);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, me.mailService.testMail.post({
                                lng: me.lng,
                                action: action,
                                email: this.authService.email,
                                firstName: this.authService.firstName || 'Какое-то firstName',
                                lastName: this.authService.lastName || 'Какое-то lastName',
                                comment: 'Отправка письма из отчёта "Тестирование"',
                            }).toPromise()];
                    case 2:
                        result = _a.sent();
                        me.resultMessage = result.error ? "\u041E\u0448\u0438\u0431\u043A\u0430: " + result.error : 'Письмо успешно отправлено';
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        me.resultMessage = "\u041E\u0448\u0438\u0431\u043A\u0430: " + err_1;
                        return [3 /*break*/, 4];
                    case 4:
                        this.inProgress = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return SendTestComponent;
}(BaseComponent));
export { SendTestComponent };
